<div class="scope-view" appUserManual [userManualKey]="'supplier-scope-view'">
  <h2>Open Scope by Procurement Package</h2>
  @if (loading$ | async) {
    <div class="status">Loading scope…</div>
  }
  @if (error$ | async; as err) {
    <div class="status error">{{ err }}</div>
  }

  <!-- Scope toolbar: search + auto-refresh toggle -->
  <div class="scope-toolbar">
    <div class="scope-search-field">
      <p-floatlabel variant="in">
        <p-iconfield class="scope-search-shell">
          <input
            pInputText
            id="scope-search"
            [formControl]="scopeSearch"
            (keyup.enter)="findTag()"
            autocomplete="off"
            class="scope-search-input"
          />

          <div class="scope-search-actions">
            <button pButton type="button" class="scope-inline-action" aria-label="Search" (click)="findTag()">
              <i class="pi pi-search"></i>
            </button>
            @if (scopeSearch.value && scopeSearch.value.length) {
              <button pButton type="button" class="scope-inline-action scope-inline-action--clear" aria-label="Clear"
                      (click)="scopeSearch.setValue(''); clearHighlight()">
                <i class="pi pi-times"></i>
              </button>
            }
          </div>
        </p-iconfield>
        <label for="scope-search">Search by tag number</label>
      </p-floatlabel>
    </div>

    <button
      pButton
      type="button"
      class="auto-refresh-btn"
      [class.active]="autoRefreshing$ | async"
      [class.spin-once]="spinAnimating"
      (click)="toggleAutoRefresh()"
      [attr.aria-pressed]="(autoRefreshing$ | async) === true"
      [attr.title]="(autoRefreshing$ | async) ? 'Auto refresh is ON (20s)' : 'Auto refresh is OFF'"
    >
      <i class="pi pi-sync"></i>
    </button>
  </div>

  <!-- Session counters: show only while auto-refresh is ON -->
  @if (autoRefreshing$ | async) {
    <div class="session-counters">
      <span class="label">Changes since monitoring started:</span>
      <div class="counter ok" aria-label="New OK count">
        <app-status-circle [status]="completionStatus.OK"></app-status-circle>
        OK: {{ newOkIds.size }} <span class="muted">({{ okProgressEstimatePct }}%)</span>
      </div>
      <div class="counter pa" aria-label="New PA count">
        <app-status-circle [status]="completionStatus.PA"></app-status-circle>
        PA: {{ newPaIds.size }}
      </div>
      <div class="counter pb" aria-label="New PB count">
        <app-status-circle [status]="completionStatus.PB"></app-status-circle>
        PB: {{ newPbIds.size }}
      </div>
    </div>
  }

  @if (groups$ | async; as groups) {
    <ng-container>
      @if (groups.length === 0) {
        <div class="empty">No open scope.</div>
      }

      @for (group of groups; track group.packageKey) {
        <div class="package-group">
          <div class="package-header" (click)="toggleGroup(group.packageKey)" role="button" tabindex="0">
            <div class="package-title">Package: {{ group.packageNumber }}</div>

            <div class="package-progress" aria-label="Procurement package progress">
              <div
                class="progress-track"
                role="progressbar"
                [attr.aria-valuenow]="getGroupProgress(group)"
                aria-valuemin="0"
                aria-valuemax="100"
              >
                <div class="progress-fill" [style.width.%]="getGroupProgress(group)"></div>
              </div>
              <div class="progress-label">{{ getGroupProgress(group) }}%</div>
            </div>

            <div class="package-meta">{{ group.assignments.length }} assignments</div>
            <button pButton type="button" class="toggle-btn" aria-label="Toggle group" tabindex="-1">
              <i [class]="group.expanded ? 'pi pi-chevron-up' : 'pi pi-chevron-down'"></i>
            </button>
          </div>

          @if (group.expanded) {
            <div class="package-table">
              <p-table
                [value]="group.assignments"
                [tableStyle]="{ 'min-width': '100%', 'table-layout': 'fixed' }"
                class="p-datatable-sm scope-table"
              >
                <ng-template pTemplate="header">
                  <tr>
                    <th>CommPkg</th>
                    <th>McPkg</th>
                    <th>System</th>
                    <th>Tag</th>
                    <th>CheckSheet</th>
                    <th>Company</th>
                    <th>McSite</th>
                    <th>Phase</th>
                    <th>Status</th>
                    <th class="progress-column">Progress</th>
                    <th>Users</th>
                  </tr>
                </ng-template>

                <ng-template pTemplate="body" let-a>
                  <tr [attr.id]="'scope-assignment-' + a.id" [class.highlight]="a.id === highlightedAssignmentId">
                    <td>{{ a.commissioningPackageNumber }}</td>
                    <td>{{ a.mcPackageNumber }}</td>
                    <td>{{ a.systemNumber || '-' }}</td>
                    <td>{{ a.tagNumber || '-' }}</td>
                    <td>{{ a.checkSheetNumber }}</td>
                    <td>{{ a.companyNumber }}</td>
                    <td>{{ a.siteNumber }}</td>
                    <td>{{ a.phaseNumber }}</td>
                    <td class="status-cell">
                      <app-status-circle [status]="toCompletionStatus(a.status || a.state)"></app-status-circle>
                    </td>
                    <td class="progress-cell">
                      <div class="progress-track" role="progressbar" [attr.aria-valuenow]="getProgress(a)"
                           aria-valuemin="0" aria-valuemax="100">
                        <div class="progress-fill" [style.width.%]="getProgress(a)"></div>
                      </div>
                    </td>
                    <td class="users-cell">
                      <div class="user-pills" aria-label="Assigned users">
                        @for (u of a.users; track u.id) {
                          <span class="user-pill">{{ u.name || u.userName }}</span>
                        }
                      </div>
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          }
        </div>
      }

    </ng-container>
  }

</div>
